/**
 * IOO-225 – Patient Account
 * Dummy data for UI development and testing.
 * Replace with real API calls when backend is ready.
 */

export const DUMMY_ACCOUNT = {
  id: 1,
  patient_id: 271,
  first_name: 'Jane',
  last_name: 'Doe',
  email: 'jane.doe@example.com',
  mobile_number: '07700900123',
  country_code: '+44',
  gender: 'female',
  date_of_birth: '1990-05-14',
  address_1: '10 Downing Street',
  address_2: '',
  city: 'London',
  country: 'United Kingdom (UK)',
  postal_code: 'SW1A 2AA',
  is_linked: true,
  is_verified: 1,
  last_login_at: '2026-05-31T16:00:00Z',
};

export const DUMMY_APPOINTMENTS = [
  {
    appointment_id: 315,
    parent_id: 'AP-0000000315',
    status: 6,
    status_label: 'Payment Booking Succeeded',
    start_time: '2026-06-10T10:30:00',
    end_time: '2026-06-10T10:45:00',
    charges: '40.00',
    type: 'appointment',
    appointment_type_int: 1,
    clinic: { id: 47, name: 'Hampstead', address: '213 Haverstock Hill, Belsize Park, London, NW3 4QP' },
    product_category: { id: 1, title: 'GP Appointment' },
    duration_label: '15 mins',
    cancellations_rescheduling_allowed: 1,
    can_cancel: true,
    can_reschedule: true,
  },
  {
    appointment_id: 290,
    parent_id: 'AP-0000000290',
    status: 2,
    status_label: 'Rescheduled',
    start_time: '2026-06-20T14:00:00',
    end_time: '2026-06-20T14:15:00',
    charges: '40.00',
    type: 'appointment',
    appointment_type_int: 1,
    clinic: { id: 12, name: 'Oxford Street', address: '6 Newburgh Street, Carnaby, London, W1F 7RQ' },
    product_category: { id: 1, title: 'GP Appointment' },
    duration_label: '15 mins',
    cancellations_rescheduling_allowed: 1,
    can_cancel: true,
    can_reschedule: false,
  },
  {
    appointment_id: 201,
    parent_id: 'AP-0000000201',
    status: 4,
    status_label: 'Cancelled',
    start_time: '2026-04-05T09:00:00',
    end_time: '2026-04-05T09:30:00',
    charges: '120.00',
    type: 'appointment',
    appointment_type_int: 1,
    clinic: { id: 22, name: 'City', address: '1 Poultry, City of London, EC2R 8EJ' },
    product_category: { id: 2, title: 'Health Screen' },
    duration_label: '30 mins',
    cancellations_rescheduling_allowed: 0,
    can_cancel: false,
    can_reschedule: false,
  },
  {
    appointment_id: 155,
    parent_id: 'AP-0000000155',
    status: 14,
    status_label: 'Completed',
    start_time: '2026-02-18T11:00:00',
    end_time: '2026-02-18T11:15:00',
    charges: '40.00',
    type: 'appointment',
    appointment_type_int: 1,
    clinic: { id: 47, name: 'Hampstead', address: '213 Haverstock Hill, Belsize Park, London, NW3 4QP' },
    product_category: { id: 1, title: 'GP Appointment' },
    duration_label: '15 mins',
    cancellations_rescheduling_allowed: 0,
    can_cancel: false,
    can_reschedule: false,
  },
];

export const DUMMY_PAYMENT_METHODS = [
  {
    id: 1,
    stripe_payment_method_id: 'pm_test_visa4242',
    card_brand: 'visa',
    card_last4: '4242',
    card_exp_month: 12,
    card_exp_year: 2027,
    cardholder_name: 'Jane Doe',
    is_default: true,
    is_expired: false,
  },
  {
    id: 2,
    stripe_payment_method_id: 'pm_test_mc5555',
    card_brand: 'mastercard',
    card_last4: '5555',
    card_exp_month: 3,
    card_exp_year: 2026,
    cardholder_name: 'Jane Doe',
    is_default: false,
    is_expired: false,
  },
  {
    id: 3,
    stripe_payment_method_id: 'pm_test_old0001',
    card_brand: 'visa',
    card_last4: '0001',
    card_exp_month: 1,
    card_exp_year: 2024,
    cardholder_name: 'J Doe',
    is_default: false,
    is_expired: true,
  },
];

/** Simulate async API call with optional delay */
export const fakeApi = (data, delay = 600) =>
  new Promise(resolve => setTimeout(() => resolve({ success: true, data }), delay));

/** Simulate async API failure */
export const fakeApiError = (message = 'Something went wrong', delay = 600) =>
  new Promise((_, reject) => setTimeout(() => reject(new Error(message)), delay));

/**
 * Dummy available time slots for the reschedule journey.
 * Each entry represents one available date with a list of time strings.
 */
export const DUMMY_RESCHEDULE_SLOTS = [
  {
    date: '2026-06-15',
    label: 'Mon, 15 Jun 2026',
    slots: ['09:00', '09:15', '09:30', '10:00', '10:30', '11:00'],
  },
  {
    date: '2026-06-16',
    label: 'Tue, 16 Jun 2026',
    slots: ['08:30', '09:00', '09:15', '10:00', '14:00', '14:30', '15:00'],
  },
  {
    date: '2026-06-17',
    label: 'Wed, 17 Jun 2026',
    slots: ['09:30', '10:00', '11:00', '11:30', '16:00'],
  },
  {
    date: '2026-06-18',
    label: 'Thu, 18 Jun 2026',
    slots: ['08:30', '09:00', '09:30', '10:30', '11:00', '14:00', '14:30'],
  },
  {
    date: '2026-06-19',
    label: 'Fri, 19 Jun 2026',
    slots: ['09:00', '09:15', '09:30', '10:00'],
  },
];

// ─────────────────────────────────────────────────────────────────────────────
// ReschedulePageV2 dummy data
// Shapes match the REAL API responses so the component renders identically.
// ─────────────────────────────────────────────────────────────────────────────

/**
 * Matches GET /api/v1/get-appointment/{key}  →  res.data.data
 * Keys: AP-0000000315, AP-0000000230, AP-0000000050
 */
export const DUMMY_RESCHEDULE_APPOINTMENTS = {
  'AP-0000000315': {
    appointment_id: 315,
    parent_id: 'AP-0000000315',
    product_category_id: 1,
    product_category_name: 'GP appointment',
    product_id: null,
    product_name: null,
    cancellation_charge: 0,
    cancellation_charge_details: { amount: 0 },
    rescheduling_charge: 0,
    rescheduling_charge_details: { amount: 0 },
    duration_text: '15 min',
    language_name: 'English',
    preferred_gender: 'no_preference',
    charges: '40.00',
    start_time: '10 Jun 2026, 10:30 AM',
    end_time: '10 Jun 2026, 10:45 AM',
    clinic_name: 'Hampstead',
    clinic_address: '74 Hampstead High St, London NW3 1RE',
    clinic_latitude: '51.5563',
    clinic_longitude: '-0.1773',
    clinic_description: '<p>Our Hampstead clinic is a modern medical facility.</p>',
    clinic_contact_number: '020 3993 0813',
    clinic_website: 'https://www.londondoctorsclinic.co.uk',
    corporate_customer: null,
    date_of_birth: '1990-05-14',
    cancellations_rescheduling_allowed: 1,
    status: 6,
  },
  'AP-0000000230': {
    appointment_id: 230,
    parent_id: 'AP-0000000230',
    product_category_id: 2,
    product_category_name: 'Health Screen',
    product_id: 5,
    product_name: 'Bronze (60 minutes)',
    cancellation_charge: 25,
    cancellation_charge_details: { amount: 25 },
    rescheduling_charge: 0,
    rescheduling_charge_details: { amount: 0 },
    duration_text: '60 min',
    language_name: 'English',
    preferred_gender: 'female',
    charges: '120.00',
    start_time: '15 Jun 2026, 09:00 AM',
    end_time: '15 Jun 2026, 10:00 AM',
    clinic_name: 'Cavendish Square',
    clinic_address: '114 Harley St, London W1G 7JL',
    clinic_latitude: '51.5201',
    clinic_longitude: '-0.1490',
    clinic_description: '<p>Our Harley Street clinic offering a wide range of services.</p>',
    clinic_contact_number: '020 3993 0813',
    clinic_website: 'https://www.londondoctorsclinic.co.uk',
    corporate_customer: null,
    date_of_birth: '1985-11-22',
    cancellations_rescheduling_allowed: 1,
    status: 6,
  },
  'AP-0000000050': {
    appointment_id: 50,
    parent_id: 'AP-0000000050',
    product_category_id: 1,
    product_category_name: 'GP appointment',
    product_id: null,
    product_name: null,
    cancellation_charge: 0,
    cancellation_charge_details: { amount: 0 },
    rescheduling_charge: 0,
    rescheduling_charge_details: { amount: 0 },
    duration_text: '30 min',
    language_name: 'English',
    preferred_gender: 'male',
    charges: '75.00',
    start_time: '20 Jun 2026, 14:00 PM',
    end_time: '20 Jun 2026, 14:30 PM',
    clinic_name: 'Victoria',
    clinic_address: '50 Victoria St, London SW1H 0NW',
    clinic_latitude: '51.4975',
    clinic_longitude: '-0.1357',
    clinic_description: '<p>Our Victoria clinic in the heart of Westminster.</p>',
    clinic_contact_number: '020 3993 0813',
    clinic_website: 'https://www.londondoctorsclinic.co.uk',
    corporate_customer: null,
    date_of_birth: '1978-03-08',
    cancellations_rescheduling_allowed: 1,
    status: 1,
  },
};

/**
 * Matches GET /api/v1/appointment-duration  (after reduce transform in rescheduleV2)
 * Shape: { [duration_id]: { duration_id, duration, content } }
 */
export const DUMMY_DURATIONS_BY_ID = {
  '1': { duration_id: 1, duration: '15', content: '15 minutes' },
  '2': { duration_id: 2, duration: '30', content: '30 minutes' },
  '3': { duration_id: 3, duration: '45', content: '45 minutes' },
  '4': { duration_id: 4, duration: '60', content: '60 minutes' },
  '5': { duration_id: 5, duration: '75', content: '75 minutes' },
  '6': { duration_id: 6, duration: '90', content: '90 minutes' },
};

/**
 * Matches GET /api/v1/languages  (after map transform in rescheduleV2)
 * Shape: Array<{ label, value }>
 */
export const DUMMY_LANGUAGES = [
  { label: 'English',  value: 1 },
  { label: 'Arabic',   value: 2 },
  { label: 'French',   value: 3 },
  { label: 'Spanish',  value: 4 },
  { label: 'Mandarin', value: 5 },
];

/**
 * Matches GET /api/v1/clinics  (raw response — rescheduleV2 uses .data array)
 * Also used to build combineAllClinicAndClinicById via reduce.
 */
export const DUMMY_CLINICS_RESPONSE = {
  data: [
    {
      id: 47,
      name: 'Hampstead',
      address: '74 Hampstead High St, London NW3 1RE',
      latitude: '51.5563',
      longitude: '-0.1773',
      clinic_website_description: '<p>Our Hampstead clinic.</p>',
      contact_number: '020 3993 0813',
      website: 'https://www.londondoctorsclinic.co.uk',
      position: 'Ground Floor',
    },
    {
      id: 40,
      name: 'Cavendish Square',
      address: '114 Harley St, London W1G 7JL',
      latitude: '51.5201',
      longitude: '-0.1490',
      clinic_website_description: '<p>Our Harley Street clinic.</p>',
      contact_number: '020 3993 0813',
      website: 'https://www.londondoctorsclinic.co.uk',
      position: 'First Floor',
    },
    {
      id: 48,
      name: 'Victoria',
      address: '50 Victoria St, London SW1H 0NW',
      latitude: '51.4975',
      longitude: '-0.1357',
      clinic_website_description: '<p>Our Victoria clinic.</p>',
      contact_number: '020 3993 0813',
      website: 'https://www.londondoctorsclinic.co.uk',
      position: 'Ground Floor',
    },
    {
      id: 45,
      name: 'Liverpool Street',
      address: '2 Liverpool St, London EC2M 7QD',
      latitude: '51.5179',
      longitude: '-0.0820',
      clinic_website_description: '<p>Our City of London clinic.</p>',
      contact_number: '020 3993 0813',
      website: 'https://www.londondoctorsclinic.co.uk',
      position: 'Ground Floor',
    },
  ],
};
